import React, { useEffect, useState } from 'react';
import { Table, Layout, Image, Switch, message, Tabs } from 'antd';
import Api from "../api";

const { Content } = Layout;
const { TabPane } = Tabs;

const ReceiptsView = () => {
    const [receipts, setReceipts] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 15,
        total: 0,
    });
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('enabled');

    useEffect(() => {
        fetchReceipts(pagination.current);
    }, [pagination.current, activeTab]);

    const fetchReceipts = async (page = 1, enabled = activeTab === 'enabled') => {
        setLoading(true);
        try {
            const res = await Api.get(`/admin/v2/receipts?page=${page}&enabled=${activeTab === 'enabled' ? 1 : 0}`);

            const response = res.data.data;

            setReceipts(response.data);
            setPagination((prev) => ({
                ...prev,
                current: response.current_page,
                total: response.total,
            }));
        } catch (err) {
            message.error('Failed to fetch receipts');
        } finally {
            setLoading(false);
        }
    };
    const handleToggle = async (receiptId) => {
        try {
            const res = await Api.put(`/admin/v2/receipts/${receiptId}/toggle`);
            const updatedReceipt = res.data.data;

            setReceipts((prev) =>
                prev.map((r) => (r.id === updatedReceipt.id ? updatedReceipt : r))
            );

            message.success(res.data.message || 'Receipt status updated');
        } catch (err) {
            message.error('Failed to toggle receipt status');
        }
    };

    const handleTableChange = (pagination) => {
        setPagination((prev) => ({
            ...prev,
            current: pagination.current,
        }));
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
        },
        {
            title: 'Email',
            dataIndex: 'email',
        },
        {
            title: 'Receipt Number',
            dataIndex: 'receipt_number',
        },
        {
            title: 'Image',
            dataIndex: 'image_url',
            render: (text) => (
                <Image style={{ maxWidth: "100px" }} src={text} alt="receipt" />
            ),
        },
        {
            title: 'Enabled',
            dataIndex: 'enabled',
            render: (enabled, record) => (
                <Switch
                    checked={enabled}
                    onChange={() => handleToggle(record.id)}
                />
            ),
        },
    ];

    const filteredReceipts = receipts.filter((r) =>
        activeTab === 'enabled' ? r.enabled : !r.enabled
    );

    return (
        <Content style={{ padding: "20px" }}>
            <h1>Receipts</h1>

            <Tabs
                activeKey={activeTab}
                onChange={(key) => {
                    setActiveTab(key);
                    setPagination((prev) => ({ ...prev, current: 1 })); // reset page
                }}
            >
                <TabPane tab="Enabled" key="enabled">
                    <Table
                        dataSource={filteredReceipts}
                        columns={columns}
                        size="small"
                        rowKey="id"
                        loading={loading}
                        pagination={{
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                            total: pagination.total,
                            showSizeChanger: false,
                        }}
                        onChange={handleTableChange}
                    />
                </TabPane>
                <TabPane tab="Disabled" key="disabled">
                    <Table
                        dataSource={filteredReceipts}
                        columns={columns}
                        size="small"
                        rowKey="id"
                        loading={loading}
                        pagination={{
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                            total: pagination.total,
                            showSizeChanger: false,
                        }}
                        onChange={handleTableChange}
                    />
                </TabPane>
            </Tabs>
        </Content>
    );
};

export default ReceiptsView;
